/**
 * O texto dos dois sinais SILENCIOSOS do parser/agente de IA: a leitura que "deu certo" sem o
 * agente, e o e-mail cuja leitura automática desistiu. Nenhum dos dois vira linha em
 * `email_erro`, então a fila de falhas e o resumo dela nunca os mostram sozinhos — por isso a
 * tela precisa de um texto à parte.
 *
 * `null` quando não há o que avisar: cada Alert só aparece com `X > 0`.
 */

import type { ResumoDasFalhasDeEmail } from './resumo';

/** "Nas últimas 24 h, a leitura rodou sem o agente de IA em 3 de 10 e-mails." */
export function textoDeLeituraSemAgente(resumo: ResumoDasFalhasDeEmail): string | null {
  if (resumo.leiturasSemAgenteUltimas24h === 0) return null;
  return (
    `Nas últimas 24 h, a leitura rodou sem o agente de IA em ${String(resumo.leiturasSemAgenteUltimas24h)} ` +
    `de ${String(resumo.leiturasUltimas24h)} e-mails.`
  );
}

/** "1 e-mail com a leitura automática desistida." / "3 e-mails com a leitura automática desistida." */
export function textoDeLeituraDesistida(resumo: ResumoDasFalhasDeEmail): string | null {
  if (resumo.leiturasDesistidas === 0) return null;
  const email = resumo.leiturasDesistidas === 1 ? 'e-mail' : 'e-mails';
  return `${String(resumo.leiturasDesistidas)} ${email} com a leitura automática desistida.`;
}
